// El Agora y los Circulos de lectura.
//
// Vivia en `lib/api.js` junto con otros veintidos apartados (R4.5). Quien lo importa
// no se entero: `@/lib/api` sigue exportando exactamente lo mismo.
import { api } from "./client";

// ---- Círculos de lectura ----

export const getReadingCircles = () =>
  api.get("/communities/circles").then((r) => r.data.circles);
export const joinReadingCircle = (id) =>
  api.post(`/communities/circles/${id}/join`).then((r) => r.data);

// ---- El Ágora (hub de comunidad) ----

export const getAgoraOverview = async () => (await api.get("/mundo/overview")).data;
export const getWeeklyChallenge = async () => (await api.get("/mundo/reto")).data;
export const submitChallengeEntry = async (text) => (await api.post("/mundo/reto/entries", { text })).data;
export const getChallengeFeed = async (challengeId, before) =>
  (await api.get("/mundo/reto/feed", { params: { challenge_id: challengeId, before } })).data;
export const reactChallengeEntry = async (entryId, payload) =>
  (await api.post(`/mundo/reto/entries/${entryId}/react`, payload)).data;
export const getAgoraMisiones = async () => (await api.get("/mundo/misiones")).data;
export const getAgoraMotor = async () => (await api.get("/mundo/motor")).data;
export const generateAgoraMotor = async ({ tema = "", host = "" } = {}) =>
  (await api.post("/mundo/motor/generate", { tema, host })).data;
export const getAgoraLiga = async () => (await api.get("/mundo/liga")).data;
export const agoraRefVisit = async (code, visitor) =>
  (await api.post("/mundo/ref/visit", { code, visitor })).data;
export const agoraRefConvert = async (code) =>
  (await api.post("/mundo/ref/convert", { code })).data;
